import { render, staticRenderFns } from "./MifareCardAccess.vue?vue&type=template&id=04857198&scoped=true"
import script from "./MifareCardAccess.vue?vue&type=script&lang=js"
export * from "./MifareCardAccess.vue?vue&type=script&lang=js"
import style0 from "./MifareCardAccess.vue?vue&type=style&index=0&id=04857198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04857198",
  null
  
)

export default component.exports